import {
    createUserContextSession,
    type UserContextResult,
    userContextQuery,
} from '@amzn/bf-playback'
import { loadCustomerId } from '@/auth/customerId'
import { webPlaybackAuth } from '@/auth/webPlaybackAuth'
import { gqlFetch, readGqlCache } from '@/service/gql'

export const userContextSession = createUserContextSession({
    auth: webPlaybackAuth,
    gql: { fetch: gqlFetch },
    loadCustomerId,
})

export function loadUserContext(): Promise<UserContextResult> {
    return userContextSession.loadUserContext()
}

/** The user context the last {@link loadUserContext} cached, while under a week old. */
export function readCachedUserContext(): Promise<UserContextResult | undefined> {
    return readGqlCache(userContextQuery, {})
}
